import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Table from 'modules/common/Table';
import TPCard from 'components/TP-UI/TPCard';
import TPCardTitle from 'components/TP-UI/TPCard/components/TPCardTitle';
import TPCardContent from 'components/TP-UI/TPCard/components/TPCardContent';
import TPGrid from 'components/TP-UI/TPGrid';
import TPCardHeader from 'components/TP-UI/TPCard/components/TPCardHeader';
import { INITIAL_AUTOMATED_WITHDRAWALS_FILTERS_VALUES } from '../../constants';
import useDashboardFilterFields from '../../hooks/useDashboardFilterFields';
import HorizontalBar from '../../components/HorizontalBar';
import LineChart from '../../components/LineChart';

const AutomatedWithdrawalsView = ({ form, failedChecks, approvalStats, loading, onChange }) => {
  const fields = useDashboardFilterFields({ form });

  const filters = useMemo(
    () => ({
      fields: fields,
      form,
      initialValues: INITIAL_AUTOMATED_WITHDRAWALS_FILTERS_VALUES,
      maxPrimaryFilters: 4,
    }),
    [form, fields],
  );

  const totalFailedChecks = useMemo(() => {
    return failedChecks?.reduce((acc, item) => acc + item.count, 0);
  }, [failedChecks]);

  const failedChecksData = useMemo(() => {
    if (!failedChecks) {
      return undefined;
    }
    return failedChecks
      ?.sort((a, b) => {
        return b.count - a.count;
      })
      .map((item) => ({
        name: item.name,
        count: totalFailedChecks ? ((item.count / totalFailedChecks) * 100).toFixed(2) : 0,
      }));
  }, [failedChecks, totalFailedChecks]);

  const approvalStatsData = useMemo(() => {
    if (!approvalStats) {
      return undefined;
    }
    return approvalStats
      ?.sort((a, b) => {
        return b.date - a.date;
      })
      .map((item) => ({
        date: item.date,
        approvalRate: item.totalCount
          ? ((item.approvedCount / item.totalCount) * 100).toFixed(2)
          : 0,
      }));
  }, [approvalStats]);

  return (
    <Table
      items={approvalStatsData}
      view="custom"
      filters={filters}
      loading={loading}
      onChange={onChange}
      scrollable={false}
      noMatchesText="No withdrawal requests for this time period"
      hidePagination>
      <TPGrid container spacing={2}>
        <TPGrid item xs={12} md={6}>
          <TPCard stretch>
            <TPCardHeader>
              <TPCardTitle>% Auto-Approval Decline Reason Share</TPCardTitle>
            </TPCardHeader>
            <TPCardContent>
              <HorizontalBar
                items={failedChecksData}
                labelKey="name"
                dataKey="count"
                label="% Auto-Approval Decline Reason Share"
              />
            </TPCardContent>
          </TPCard>
        </TPGrid>
        <TPGrid item xs={12} md={6}>
          <TPCard stretch>
            <TPCardHeader>
              <TPCardTitle>% Passed Automated Withdrawals</TPCardTitle>
            </TPCardHeader>
            <TPCardContent>
              <LineChart
                items={approvalStatsData}
                labelKey="date"
                dataKey="approvalRate"
                height={400}
                label="% Passed Automated Withdrawals"
              />
            </TPCardContent>
          </TPCard>
        </TPGrid>
      </TPGrid>
    </Table>
  );
};

AutomatedWithdrawalsView.propTypes = {
  loading: PropTypes.bool,
  failedChecks: PropTypes.array,
  approvalStats: PropTypes.array,
  form: PropTypes.string,
  onChange: PropTypes.func,
};

export default AutomatedWithdrawalsView;
